import { BuyInInfo, PrivateRoomInfo } from 'types/game';

export function privateRoomToBuyInInfo(room: PrivateRoomInfo): BuyInInfo {
  return {
    tableProfileId: 0,
    tableName: room.tableName,
    variantCode: room.variantCode,
    bootAmount: room.bootAmount,
    minBet: room.minBet,
    maxBet: room.maxBet,
    minBuyIn: room.minBuyIn,
    maxBuyIn: room.maxBuyIn,
    availableBalance: room.availableBalance,
    activeTableStack: room.activeTableStack,
    currencySymbol: room.currencySymbol,
    currencyCode: room.currencyCode ?? undefined,
    canJoin: room.canJoin,
    joinBlockReason: room.joinBlockReason,
    balanceVerified: room.balanceVerified,
  };
}
